/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Pumpspermutationday2Inputs */



/**
* | output |
* | --- |
* | "Pumps permutation day" |
*
* @param {Br_History_Key_Pumpspermutationday2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_pumpspermutationday2 = /** @type {((inputs?: Br_History_Key_Pumpspermutationday2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Pumpspermutationday2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pumps permutation day")
	return /** @type {LocalizedString} */ ("Jour de permutation des pompes")
});
export { br_history_key_pumpspermutationday2 as "br_history_key_pumpsPermutationDay" }